<ng-template #tooltipTemplate>
  <div class="tooltip-box max-w-[90vw] px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-xs dark:bg-gray-700">
    <ng-content></ng-content>
  </div>
</ng-template>
